import { useEffect, useState } from "react";
import { Flame, Award, Camera } from "lucide-react";
import api from "../lib/api";

const ICONS = { flame: Flame, award: Award, camera: Camera };
let cache = null;
let cacheAt = 0;

export function useBadges() {
  const [badges, setBadges] = useState(cache || {});
  useEffect(() => {
    let alive = true;
    if (cache && Date.now() - cacheAt < 60000) {
      setBadges(cache);
      return;
    }
    api.get("/badges").then((r) => {
      cache = r.data;
      cacheAt = Date.now();
      if (alive) setBadges(r.data);
    }).catch(() => {});
    return () => { alive = false; };
  }, []);
  return badges;
}

export default function BadgeChip({ badge, testid }) {
  if (!badge) return null;
  const Icon = ICONS[badge.icon] || Award;
  return (
    <span data-testid={testid || `badge-${badge.id}`} title={badge.label}
      className="inline-flex items-center gap-1 text-[9px] font-mono uppercase tracking-[0.12em] text-kinetic border border-kinetic/30 rounded-full px-1.5 py-0.5 shrink-0">
      <Icon size={9} fill={badge.icon === "flame" ? "currentColor" : "none"} /> {badge.label}
    </span>
  );
}
